import apiBase from '../utils/baseApi';

// Contributor Media Upload API
export interface UploadFileResponse {
  url: string;
  blobName: string;
  success: boolean;
}

export const uploadContributorMedia = async (
  file: File,
  contributorId: string,
  mediaType: 'thumbnail' | 'desktop' | 'mobile',
): Promise<UploadFileResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  // Add query parameters to the URL
  const url = `/api/admin/storage/upload-contributor-media?contributorId=${encodeURIComponent(
    contributorId,
  )}&mediaType=${encodeURIComponent(mediaType)}`;

  const response = await apiBase.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

// Update contributor with new media URLs
export interface UpdateContributorMediaRequest {
  thumbnailUrl?: string;
  videoDesktopUrl?: string;
  videoMobileUrl?: string;
}

export const updateContributorMedia = async (
  contributorId: string,
  mediaData: UpdateContributorMediaRequest,
): Promise<any> => {
  try {
    const response = await apiBase.patch(
      `/api/admin/contributors/${contributorId}`,
      mediaData,
    );
    return response.data;
  } catch (error) {
    console.error('Error updating contributor media:', error);
    throw error;
  }
};
